import { AnyAction } from 'redux';
import { types } from './assignmentPresets.actions';
import { AssignmentPresetsStateType } from './assignmentPresets.types';

const initialState: AssignmentPresetsStateType = {
    saving: false,
    conflict: false,
    error: false,
    lastSavedId: undefined,
    byAccount: {},
};

const reducer = (state = initialState, action: AnyAction): AssignmentPresetsStateType => {
    switch (action.type) {
        case types.CREATE_PRESET:
        case types.UPDATE_PRESET:
        case types.DELETE_PRESET:
            return { ...state, saving: true, conflict: false, error: false };
        case types.SAVE_PRESET_DONE:
            return { ...state, saving: false, conflict: false, error: false, lastSavedId: action.id };
        case types.SAVE_PRESET_CONFLICT:
            return { ...state, saving: false, conflict: true };
        case types.SAVE_PRESET_ERROR:
            return { ...state, saving: false, error: true };
        case types.RESET_PRESET_STATUS:
            return { ...initialState, byAccount: state.byAccount };
        case types.PRESETS_RECEIVED:
            return { ...state, byAccount: { ...state.byAccount, [action.accountId]: action.presets } };
        default:
            return state;
    }
};

export default reducer;
